
import Grid from '@mui/material/Grid';
import { OrderWithItems } from 'common-models';
import { FC } from "react";

import { SwishPaymentData } from 'common-models';
import { useGetSwishPaymentForOrderQuery } from "../../../features/events/eventShopApiSlice";


type SwishPaymentFailedProps = {
    order: OrderWithItems,
}

const SwishPaymentFailed: FC<SwishPaymentFailedProps> = ({ order }) => {
    const { data: swishPaymentFromApi = undefined as unknown as SwishPaymentData } = useGetSwishPaymentForOrderQuery(order.id);

    const getErrorText = () => {
        if (swishPaymentFromApi) {
            switch (swishPaymentFromApi.errorCode) {
                case 'FF08': return 'Ogilgig betalningsreferens.';
                case 'BE18': return 'Ogiltigt Swishnummer.'; //'Payer alias is invalid.';
                case 'ACMT03': return 'Ogiltigt Swishnummer';  //'Payer not Enrolled.';
                case 'VR01': return 'Åldersgräns inte uppnådd.'; //	Does not meet age limit.Note: Only M - Commerce case, for E - Commerce case the simulated error will trigger in the ‘Payment request created’ step(first response).
                case 'VR02': return 'Ogiltigt Swishnummer'; //'The payer alias in the request is not enroled in swish with the supplied ssn.';
                case 'RF07': return 'Betalningen godkändes inte av Swish.'; // Transaction declined
                case 'BANKIDCL': return 'Signeringen avbröts i BankId.'; // Payer cancelled BankId signing
                case 'FF10': return 'Fel vid kontakt med banken.'; // Bank system processing error
                case 'DS24': return 'Fel vid kommunikation med banken. NOTERA: detta kan betyda att betalningen har genomförts.';
            }
        }

        return '';
    }

    return (
        <Grid
            size={{ xs: 12, sm: 12, lg: 4 }}>
            {/* <MobileView> */}
            {
                swishPaymentFromApi
                    ?
                    <Grid container>
                        {getErrorText()} {
                            swishPaymentFromApi
                                ? `(${swishPaymentFromApi.errorCode})`
                                : <></>
                        }
                    </Grid>
                    : <></>
            }
        </Grid>
    );
    // }
};

export { SwishPaymentFailed };
